module.exports = __webpack_public_path__ + "static/media/24austynskit.b0c366fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/24austynskit.png
// module id = 119
// module chunks = 0